import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import Inch from "../../../../components/Math/Units/Imperial/Inch";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { selectHoleSize } from "../../../../store/slices/fhwaSlice";
import DrillBitDiameterDropDown from "./DrillBitDiameterDropDown";

function DrillBitDiameter({ readonly, showModal }) {
  const holeSize = useSelector(selectHoleSize);
  const { t } = useTranslation("translation");

  const metricUnit = <Millimetre />;
  const imperialUnit = <Inch />;

  const dispaly = (
    <span className="input">
      <NumberFormatText value={holeSize.current} decimalScale={2} />
    </span>
  );

  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Bit/Hole Size")}</p>}
      inputValue={readonly ? dispaly : <DrillBitDiameterDropDown />}
      unitValue={<ConvertUnit Metric={metricUnit} Imperial={imperialUnit} />}
      formulaValue={
        !readonly && (
          <span className="input--formula" onClick={() => showModal(true)}>
            <PlusIcon />
          </span>
        )
      }
    />
  );
}

export default DrillBitDiameter;
